import { isLockedWidget } from '@/components/forms/utils/links';
import { Input } from '@/shadcn/input';
import { type WidgetWriterProps } from '../widget.type';
import { TestId } from '@/types/testId';

export const TextInput = ({
  id,
  value = '',
  label = '',
  name,
  placeholder,
  disabled = false,
  options = {},
  onChange,
  invalid,
  formContext
}: WidgetWriterProps) => {
  const isLocked = isLockedWidget(id, formContext?.links);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const value = inputValue === '' ? options.emptyValue || '' : inputValue;
    onChange(value);
  };

  return (
    <Input
      id={id}
      value={value === null ? '' : value.toString()}
      onChange={handleChange}
      type={options.inputType || 'text'}
      disabled={disabled || isLocked}
      placeholder={placeholder || 'Aa'}
      invalid={invalid}
      aria-label={label}
      data-testid={TestId.FormWriter.TextInput}
      data-cy={`text-${name}`}
    />
  );
};
